import { css, cva } from "styled-system/css";
export { pageContainerStyles as pageStyles, pageHeaderStyles as headerStyles } from "#/app.css";
export {
  filterInputContainerStyles as searchInputContainerStyles,
  filterInputStyles as searchInputStyles,
  filterInputIconStyles as searchIconStyles,
} from "#/app.css";

export const spinAnimation = css({
  animation: "spin 1s linear infinite",
});

export const titleStyles = css({
  fontFamily: "sans",
  fontWeight: "900",
  letterSpacing: "-0.025em",
  color: "textBase",
  fontSize: "h2",
});

export const subtitleStyles = css({
  fontSize: "sm",
  fontWeight: "700",
  color: "textBase/40",
});

export const loadingStyles = css({
  paddingY: "xxl",
  textAlign: "center",
  fontWeight: "700",
  color: "textBase/60",
});

export const formStyles = css({
  marginBottom: {
    base: "lg",
    md: "xxl",
  },
  position: "relative",
});

export const searchBarContainerStyles = css({
  display: "flex",
  alignItems: "center",
  gap: "sm",
});

export const filterButtonStyles = cva({
  base: {
    cursor: "pointer",
    flexShrink: 0,
    width: "2rem",
    height: "2rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "full",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "bgBase300",
    backgroundColor: "bgBase100",
    color: "textBase/60",
    transition: "all 200ms",
    _hover: {
      borderColor: "textBase/40",
      color: "textBase",
    },
  },
  variants: {
    active: {
      true: {
        borderColor: "primary",
        color: "primary",
        backgroundColor: "color-mix(in srgb, {colors.primary}, transparent 90%)",
      },
    },
  },
});

export const searchSubmitBtnStyles = css({
  cursor: "pointer",
  flexShrink: 0,
  width: "2rem",
  height: "2rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "medium",
  border: "none",
  backgroundColor: "primary",
  color: "primaryContent",
  transition: "all 200ms",
  _hover: {
    backgroundColor: "color-mix(in srgb, {colors.primary}, #000 10%)",
  },
  _active: {
    transform: "translateY(1px)",
  },
  _disabled: {
    opacity: 0.7,
    cursor: "not-allowed",
  },
});

export const dropdownStyles = css({
  position: "absolute",
  top: "100%",
  right: 0,
  marginTop: "sm",
  zIndex: 50,
  backgroundColor: "bgBase100",
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: "bgBase300",
  borderRadius: "medium",
  boxShadow: "0 10px 15px -3px rgb(0 0 0 / 0.1)",
  minWidth: "200px",
  maxWidth: "calc(100vw - 2rem)",
  maxHeight: "300px",
  overflowY: "auto",
  display: "flex",
  flexDirection: "column",
});

export const dropdownItemStyles = cva({
  base: {
    cursor: "pointer",
    transition: "all 200ms",
    userSelect: "none",
    border: "none",
    outline: "none",
    paddingInline: "md",
    paddingY: "sm",
    textAlign: "left",
    fontSize: "sm",
    backgroundColor: "transparent",
    color: "textBase",
    _hover: {
      backgroundColor: "bgBase200",
    },
  },
  variants: {
    active: {
      true: {
        backgroundColor: "color-mix(in srgb, {colors.primary}, transparent 90%)",
        color: "primary",
        fontWeight: "600",
      },
    },
  },
});

export const gridStyles = css({
  display: "grid",
  gridTemplateColumns: {
    base: "repeat(3, 1fr)",
    sm: "repeat(4, 1fr)",
    lg: "repeat(5, 1fr)",
    xl: "repeat(6, 1fr)",
  },
  gap: {
    base: "sm",
    sm: "md",
  },
});

export const sourceTagStyles = css({
  color: "textBase/40",
  backgroundColor: "bgBase200",
  fontWeight: "800",
  fontSize: "9px",
  textTransform: "uppercase",
  display: "inline-block",
  paddingY: "0.125rem",
  borderRadius: "0.25rem",
  marginBottom: "0.125rem",
  width: "fit-content",
});

export const resultCardStyles = css({
  display: "flex",
  flexDirection: "column",
  gap: "0.125rem",
  cursor: "pointer",
  backgroundColor: "transparent",
  borderRadius: 0,
  border: "none",
  boxShadow: "none",
  padding: 0,
  overflow: "visible",
  height: "100%",
  minWidth: 0,
  transition: "transform 200ms",
  _hover: {
    transform: "translateY(-4px)",
  },
});

export const imageWrapperStyles = css({
  position: "relative",
  width: "100%",
  aspectRatio: "2/3",
  borderRadius: 0,
  overflow: "hidden",
  boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
  backgroundColor: "bgBase300",
  flexShrink: 0,
});

export const imageStyles = css({
  width: "100%",
  height: "100%",
  objectFit: "cover",
  display: "block",
});

export const resultContentStyles = css({
  display: "flex",
  flexDirection: "column",
  gap: "0.125rem",
  paddingInline: "0.25rem",
  paddingY: 0,
});

export const imagePlaceholderStyles = css({
  position: "absolute",
  top: 0,
  left: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  height: "100%",
  color: "textBase/70",
  backgroundColor: "bgBase200",
});

export const resultTitleStyles = css({
  fontSize: "xs",
  fontWeight: "700",
  color: "textBase",
  lineHeight: 1.25,
  marginTop: 0,
  marginBottom: "sm",
  display: "-webkit-box",
  WebkitLineClamp: 2,
  // @ts-expect-error WebkitBoxOrient for line-clamp
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
});

export const resultMetaWrapperStyles = css({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: "xs",
});

export const resultMetaStyles = css({
  fontSize: "11px",
  color: "textBase/50",
  display: "flex",
  alignItems: "center",
});

export const inLibraryBadgeStyles = css({
  fontSize: "10px",
  fontWeight: "700",
  color: "success",
  backgroundColor: "success/10",
  paddingInline: "xs",
  borderRadius: "small",
  display: "flex",
  alignItems: "center",
  gap: "0.25rem",
  boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1)",
});

export const addButtonStyles = css({
  cursor: "pointer",
  border: "none",
  outline: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "2rem",
  height: "2rem",
  color: "primaryContent",
  backgroundColor: "primary",
  borderRadius: "full",
  boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1)",
  transition: "transform 0.2s, background-color 0.2s",
  _hover: {
    transform: "scale(1.1)",
    backgroundColor: "primary/10",
  },
  _active: {
    transform: "scale(0.95)",
  },
  _disabled: {
    opacity: 0.7,
    cursor: "not-allowed",
  },
  "&[aria-disabled=true]": {
    opacity: 0.7,
    cursor: "not-allowed",
  },
});

export const overlayActionStyles = css({
  position: "absolute",
  bottom: "sm",
  right: "sm",
  zIndex: 10,
});
